<template>
  <main id="content" role="main" class="main">
    <div class="position-fixed top-0 end-0 start-0 bg-img-start"
      style="height: 32rem; background-image: url(/assets/svg/components/card-6.svg);">
      <div class="shape shape-bottom zi-1">
        <svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1921 273">
          <polygon fill="#fff" points="0,273 1921,273 1921,0 " />
        </svg>
      </div>
    </div>
    <slot></slot>
    <router-view></router-view>

  </main>
</template>
<script>
export default {
  name: "AppLayoutGuest",
  title: "",

  mounted() {
    this.setBodyClass()
  },
  methods: {
    setBodyClass(addClass = false) {
      const body = document.querySelector("body");
      if (addClass) {
        body.classList.add("has-navbar-vertical-aside")
        body.classList.add("navbar-vertical-aside-show-xl")
        body.classList.add("footer-offset")
      } else {
        body.classList.remove("has-navbar-vertical-aside")
        body.classList.remove("navbar-vertical-aside-show-xl")
        body.classList.remove("footer-offset")
      }
    },
  },
  beforeUnmount() {
    this.setBodyClass(true)
  }
}
</script>